export { default as PersonalInfo } from './personal-info';
